var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { ClickAwayListener, Tooltip as MuiTooltip, Box as MuiBox } from '@mui/material';
import { TooltipDesignStyles, TooltipPlacements } from './types';
import { getAttributes } from '../../../utils';
var T = function (_a) {
    var props = __rest(_a, []);
    var _b = props.placement, placement = _b === void 0 ? TooltipPlacements.Top : _b, title = props.title, children = props.children, className = props.className, _c = props.designStyle, designStyle = _c === void 0 ? TooltipDesignStyles.Default : _c, _d = props.clickable, clickable = _d === void 0 ? false : _d, isOpen = props.isOpen, onClose = props.onClose, rest = __rest(props, ["placement", "title", "children", "className", "designStyle", "clickable", "isOpen", "onClose"]);
    var _e = useState(false), open = _e[0], setOpen = _e[1];
    var handleToggleTooltip = function () {
        setOpen(function (prev) { return !prev; });
    };
    var handleTooltipClose = function () {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        setOpen(false);
    };
    var disableFocus = clickable || isOpen !== undefined;
    var tooltipConfig = __assign(__assign(__assign({}, (placement ? { placement: placement.toLowerCase() } : {})), { title: title, children: children, PopperProps: __assign(__assign({}, (disableFocus ? { disablePortal: true } : {})), { className: [
                className,
                designStyle === TooltipDesignStyles.Primary && 'primary'
            ]
                .filter(Boolean)
                .join(' ') }), open: isOpen !== undefined ? isOpen : open, onClose: handleTooltipClose, onOpen: function () { return setOpen(true); } }), (disableFocus
        ? {
            disableFocusListener: true,
            disableHoverListener: true,
            disableTouchListener: true
        }
        : null));
    var baseBoxConfig = __assign({ onClick: handleToggleTooltip }, getAttributes(rest));
    return (React.createElement(ClickAwayListener, { onClickAway: handleTooltipClose },
        React.createElement(MuiTooltip, __assign({}, tooltipConfig),
            React.createElement(MuiBox, __assign({}, baseBoxConfig), children))));
};
export { T as Tooltip };
